import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getExpirationDate } from "../../welders/lookup/utils";
import { Renewal, RenewalWelder } from "@/api/williams/renewals";
import { useFormContext } from "react-hook-form";
import { useWelderExpirations } from "../hooks";

export function WelderRow({ welder }: { welder: RenewalWelder }) {
  const form = useFormContext<Renewal>();
  const data = form.watch();
  const expirations = useWelderExpirations(welder.welderId, data);

  function handleChanged(update: boolean, reinstatement: boolean) {
    const updatedWelders = data.welders.map((x) =>
      x.welderId === welder.welderId ? { ...x, update, reinstatement } : x
    );

    form.setValue("welders", updatedWelders, {
      shouldDirty: true,
    });
  }

  function handleRemoveWelder() {
    const updatedWelders = data.welders.filter((x) => x.welderId !== welder.welderId);
    form.setValue("welders", updatedWelders, {
      shouldDirty: true,
    });
  }

  return (
    <tr>
      <td className="text-start">
        <button
          type="button"
          className="btn btn-link text-black p-0 lh-sm"
          title="Remove Welder"
          onClick={handleRemoveWelder}
        >
          <FontAwesomeIcon role="button" icon={faXmark} border={true} />
        </button>
        <span className="ms-2">{welder.name}</span>
      </td>
      <td>{getExpirationDate(expirations.data?.cfR192) ?? "-"}</td>
      <td>{getExpirationDate(expirations.data?.cfR195) ?? "-"}</td>
      <td>{getExpirationDate(expirations.data?.basic) ?? "-"}</td>
      <td>{getExpirationDate(expirations.data?.basicNde) ?? "-"}</td>
      {/* <td>
        <input
          type="radio"
          name={`row_${welder.welderId}`}
          className="form-check-input"
          checked={welder.update}
          onChange={(e) => handleChanged(e.target.checked, !e.target.checked)}
        />
      </td>
       <td>
        <input
          type="radio"
          name={`row_${welder.welderId}`}
          className="form-check-input"
          checked={welder.reinstatement}
          onChange={(e) => handleChanged(!e.target.checked, e.target.checked)}
        />
      </td>  */}
    </tr>
  );
}
